/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Estimated/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Estimated({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Summary/Content/Content/Progress/Content/Content/StartDate/Estimated"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let treatmentStartDateValueData = fromData.useDataValue({ viewPath,
context: 'treatment',
path: 'start_date',
})
let treatmentEstimatedStartDateValueData = fromData.useDataValue({ viewPath,
context: 'treatment',
path: 'estimated_start_date',
})
let aggregateData = fromHelpers.getView(treatmentStartDateValueData, treatmentEstimatedStartDateValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}